import React from 'react';
import {Box, IconButton, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import ArrowUpIcon from '../../assets/arrow-up.svg';
import ArrowDownIcon from '../../assets/arrow-down.svg';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  arrowButton: {
    padding: '4px',
  },
  label: {
    fontSize: '13px',
    color: '#67716E',
    fontWeight: 500,
    minWidth: 40,
    textAlign: 'center',
    userSelect: 'none',
  },
};

const CommentNavigationBar = ({currentIndex, totalCount, onNext, onPrev}) => {
  if (totalCount === 0) return null;

  const displayIndex = currentIndex >= 0 ? currentIndex + 1 : '--';

  return (
    <Box sx={styles.container}>
      <IconButton
        onClick={onPrev}
        disabled={totalCount <= 1}
        sx={styles.arrowButton}
        aria-label="Previous comment"
      >
        <img src={ArrowUpIcon} alt="Previous comment" />
      </IconButton>
      <Typography sx={styles.label}>
        {displayIndex}/{totalCount}
      </Typography>
      <IconButton
        onClick={onNext}
        disabled={totalCount <= 1}
        sx={styles.arrowButton}
        aria-label="Next comment"
      >
        <img src={ArrowDownIcon} alt="Next comment" />
      </IconButton>
    </Box>
  );
};

export default CommentNavigationBar;

CommentNavigationBar.propTypes = {
  currentIndex: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
};
